import React, { useEffect, useState } from 'react';
import { getZerodhaConfig, updateZerodhaConfig } from './../../actions/configurationActions';
import { useDispatch, useSelector } from 'react-redux';
import { isEmpty } from 'lodash';

const ZerodhaLogin = (props) => {
    const dispatch = useDispatch();
    const configurationState = useSelector((state) => state.configuration);
    const { zerodhaConfig = {}, zerodhaSaveConfigResponse = {} } = configurationState;
    const urlParams = new URLSearchParams(window.location.search);
    const request_token = urlParams.get('request_token'); // Get the value of 'r'
    const [displayLabel, setDisplayLabel] = useState('Zerodha Login.....');

    useEffect(() => {
        dispatch(getZerodhaConfig());
    }, []);

    useEffect(() => {
        if (!isEmpty(zerodhaConfig)) {
            const { data = {} } = zerodhaConfig;
            const newData = { ...data, requestToken: request_token, generateCheckSum: true };
            dispatch(updateZerodhaConfig({ ...zerodhaConfig, data: newData }))
        }
    }, [zerodhaConfig]);

    useEffect(() => {
        if (!isEmpty(zerodhaSaveConfigResponse)) {
            const { status = {} } = zerodhaSaveConfigResponse;
            const { success = false } = status;
            if (success) {
                setDisplayLabel('Login Success. Close the window.')
                window.close();
            } else {
                setDisplayLabel('Login Failed. Try again')
            }
        }
    }, [zerodhaSaveConfigResponse]);

    return (
        <div>
            {displayLabel}
        </div>

    )
}

export default ZerodhaLogin;